"use client";

import styles from "./styles/ContentItemPage.module.scss";
import { ReactiveContentItem } from "../../components/schoolfeed/SchoolFeedContentItem";
import NewsModalContent from "../../components/modals/NewsModal/NewsModalContent";
import { deleteContentItem } from "../../components/blocks/TerracedGridTheme/Terrace";
import { useEffect } from "react";
import SafeRouter from "../../components/utilities/SafeRouter";
import { useStores } from "../../stores/useStores";
import { useMainUrl } from "../../hooks/useMainUrl";
import { useFeatureFlags } from "../../utils/featureFlags/useFeatureFlags";

export default function NewsItemPage(props: { item: NewsContentItem }) {
  const { userStore, modalStore } = useStores();
  const { show_meritocracy_chat } = useFeatureFlags();

  const homeUrl = useMainUrl();

  useEffect(() => {
    if (
      show_meritocracy_chat &&
      props.item &&
      props.item.meritchat_enabled &&
      !userStore.id
    ) {
      modalStore.addModal({
        type: "login",
      });
    }
  }, []);

  async function handleDelete(contentItem) {
    await deleteContentItem(contentItem);
    SafeRouter.push("/");
  }

  return (
    <div className={styles.container}>
      {props.item ? (
        <NewsModalContent
          closeFunction={() => SafeRouter.push(homeUrl)}
          itemObj={new ReactiveContentItem(props.item)}
          index={0}
          handleDelete={handleDelete}
        />
      ) : (
        <div className={styles.loadingIndicator}>Content Item not found.</div>
      )}
    </div>
  );
}
